import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {  
    editRangeWedgePlay,
    editRangeChipping,
    editRangeBunkerPlay
 } from 'Actions';

class EditItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            seldate:new Date(this.props.data.seldate),             
            eid:this.props.data.eid, 
            student:this.props.data.student, 
            selfrom:this.props.data.selfrom,
        };
    }


    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });        
    }    

    editHandleSubmit(event){
        event.preventDefault();
        var id=this.state.eid;
        var stdid=this.state.student;
        var selfrom=this.state.selfrom;
        if(selfrom==1){
            this.props.editRangeWedgePlay(event, id, stdid);
        }else if(selfrom==2){
            this.props.editRangeChipping(event, id, stdid);
        }else if(selfrom==3){
            this.props.editRangeBunkerPlay(event, id, stdid);
        }

        setTimeout(() => {
            this.props.onClick();
        }, 2000);
        
    }  


render() {
      
    const { particularrangewedgeplay, particularrangechipping, particularrangebunkerplay, loading} = this.props; 
  
    var addtitle="";
    var selform=this.state.selfrom; 
    if(selform==1){
       var resvalue=particularrangewedgeplay;
       addtitle="Edit Wedge Play";
    }else if(selform==2){
        var resvalue=particularrangechipping;
        addtitle="Edit Chipping";
    }else if(selform==3){
        var resvalue=particularrangebunkerplay;
        addtitle="Edit Bunker Play";
    }

      return(
        <div>
             <div className="col-md-12">
                <form autoComplete="off" id="editform" onSubmit={(e)=>this.editHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-md-8" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading={addtitle}>   
                                <div className="row float-right"> 
                                    <button type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} >Back</button>
                                </div>  
                                    <div className="row">   
                                        <div className="col-sm-12 col-md-7">
                                            <FormGroup>
                                                <Label for="date">Date *</Label>
                                                <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    /> 
                                            </FormGroup>                                          
                                        </div>                               
                                        <div className="col-sm-12 col-md-7">   
                                            <FormGroup>
                                                <Label for="name">Coach Name *</Label>
                                                <input type="text" name="coachname" id="coachname" className="form-control form-control-alternative" defaultValue={resvalue.gri_coachname} required/>
                                            </FormGroup>  
                                        </div> 
                                        <div className="col-sm-12 col-md-10">
                                            <FormGroup>
                                                <Label for="Select">Observation</Label>
                                                <textarea rows="3" type="text" name="observation" id="observation" className="form-control form-control-alternative" defaultValue={resvalue.gri_observation}></textarea>
                                            </FormGroup>
                                       </div>
                                       <div className="col-sm-12 col-md-10">
                                            <FormGroup>
                                                <Label for="Select">Work in Progress</Label>
                                                <textarea rows="3" type="text" name="workin" id="workin" className="form-control form-control-alternative" defaultValue={resvalue.gri_workinprocess}></textarea>
                                            </FormGroup>
                                       </div>
                                       <div className="col-md-12">
                                        <div className="form-group"> 
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />     
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                       </div>
                </div>
              
    )
   
}
 
}

const mapStateToProps = ({ rangeshortgame}) => {
   
    const { particularrangewedgeplay, particularrangechipping, particularrangebunkerplay, loading } = rangeshortgame;
    return { particularrangewedgeplay, particularrangechipping, particularrangebunkerplay, loading };
   
}


export default connect(mapStateToProps, {
    editRangeWedgePlay,
    editRangeChipping,
    editRangeBunkerPlay
})(EditItems);
